import ShoppingCart from "../../components/shopping-cart/ShoppingCart";
import UserMenu from "../../components/UserMenu";
import { gaSendEvent, GTMEvent } from "../../utils/Utils";
import NotificationCompleteProfile from "../../components/NotificationCompleteProfile";

class HeaderClass{
    constructor(){
        this.main = document.getElementById('header');
        
        if(this.main){
            this._init();
        }
    }

    _init(){
        this._shoppingCartBtn = document.getElementById('header_shopping_cart_btn');
        this._isSticky = this.main.hasAttribute('data-sticky');
        this._isStickyActive = false;

        this._hasBackgroundTransparent = this.main.classList.contains('header--background-transparent');
        
        if(this._shoppingCartBtn){
            this._shoppingCartBtn.addEventListener('click', this._onClickShoppingCartBtn.bind(this));
            ShoppingCart.addEventListener('cartChange', this._onShoppingCartChange.bind(this));
        }

        if(this._isSticky){
            window.addEventListener('scroll', this._onScroll.bind(this));
        }
        NotificationCompleteProfile.init();
        
    }

    _onShoppingCartChange(e){
        if(ShoppingCart.itemsCount == 0){
            this._shoppingCartBtn.classList.remove('button--bubble-show');
        }else{
            this._shoppingCartBtn.classList.add('button--bubble-show');
        }
    }

    _onClickShoppingCartBtn(e){
        gaSendEvent('Header', 'Click My List', 'Header My List');
        let GTMICarttems = [];
        ShoppingCart.data.items.forEach(item => {
            GTMICarttems.push({item_id:item.id, item_name:item.name, price:item.price, quantity: '1'});
        });
        GTMEvent('view_cart',{ecommerce: {currency:'USD', tax: '0', shipping:'0', value: ShoppingCart.getTotalCartNumber, items:GTMICarttems}});

        ShoppingCart.show();
    }

    _onScroll(e){
        let scrollY = Math.max(document.documentElement.scrollTop, document.body.scrollTop);

        if(this._isStickyActive && scrollY < this.main.offsetHeight){
            this._isStickyActive = false;

            this.main.classList.add('header--sticky-hide');

            setTimeout(()=> {
                if(this._hasBackgroundTransparent) {
                    this.main.classList.add('header--background-transparent');
                }

                this.main.classList.remove('header--sticky-show');
                this.main.classList.remove('header--sticky-hide');
                this.main.classList.remove('header--sticky');
            }, 250);
        }

        if(!this._isStickyActive && scrollY >= this.main.offsetHeight + 20){
            this._isStickyActive = true;

            if(this._hasBackgroundTransparent){
                this.main.classList.remove('header--background-transparent');
            }

            this.main.classList.add('header--sticky');
            setTimeout(()=>{
                this.main.classList.add('header--sticky-show');    
            }, 50);
        }
    }
}

const Header = new HeaderClass();
Object.seal(Header);

export default Header;